import React from "react";
import { FaHome, FaUserCheck, FaSignal, FaBuffer, FaHive, FaAddressBook } from "react-icons/fa";
import { MdLocationOn, MdChat } from "react-icons/md";
import { AiFillWindows } from "react-icons/ai";
import { IoIosFingerPrint, IoMdCog, IoIosLocate, IoIosPerson, IoIosStar } from "react-icons/io";

// Icons inherit their colour from the sidebar link (currentColor) so the
// active/hover states can restyle them. `add` is the quick "+" link.
export const SideBarGroups = ["Overview", "Residences", "People"];

export const SideBarItems = [
	{ group: "Overview", name: "Dashboard", href: "dashboard", icon: <FaSignal /> },
	{ group: "Overview", name: "Reviews", href: "reviews", icon: <MdChat /> },
	{ group: "Overview", name: "Reports", href: "reports", icon: <AiFillWindows /> },

	{
		group: "Residences",
		name: "Residences",
		href: "residences",
		icon: <FaHome />,
		add: { name: "Add Residence", href: "residences/add" },
	},
	{
		group: "Residences",
		name: "Zones",
		href: "zones",
		icon: <MdLocationOn />,
		add: { name: "Add Zone", href: "zones/add" },
	},
	{
		group: "Residences",
		name: "Locations",
		href: "locations",
		icon: <IoIosLocate />,
		add: { name: "Add Location", href: "locations/add" },
	},
	{
		group: "Residences",
		name: "R Classes",
		href: "classes",
		icon: <FaBuffer />,
		add: { name: "Add Class", href: "classes/add" },
	},
	{
		group: "Residences",
		name: "R Facilities",
		href: "facilities",
		icon: <IoMdCog />,
		add: { name: "Add Facility", href: "facilities/add" },
	},
	{ group: "Residences", name: "Registration", href: "registration", icon: <IoIosFingerPrint /> },

	{
		group: "People",
		name: "Senior Tutors",
		href: "snr-tutors",
		icon: <FaUserCheck />,
		add: { name: "Add Tutor", href: "snr-tutors/add" },
	},
	{
		group: "People",
		name: "Counsellors",
		href: "counsellors",
		icon: <FaAddressBook />,
		add: { name: "Add Counsellor", href: "counsellors/add" },
	},
	{
		group: "People",
		name: "Student MPs",
		href: "student-mps",
		icon: <IoIosPerson />,
		add: { name: "Add Area-Mp", href: "student-mps/add" },
	},
	{
		group: "People",
		name: "Assembly Memb.",
		href: "assembly-members",
		icon: <IoIosStar />,
		add: { name: "Add A. Member", href: "assembly-members/add" },
	},
	{
		group: "People",
		name: "NSS Personnels",
		href: "nss-personnels",
		icon: <FaHive />,
		add: { name: "Add Personnel", href: "nss-personnels/add" },
	},
];
